<section class="content">
  <section>
    <div class="row">
     <div class="equipment-card">
  <!-- Header -->
  <div class="equipment-header">
    <h2 *ngIf="equipmentId" class="equipment-title">
      {{ divisionName ? divisionName + ' - ' + categoryName : categoryName }}
    </h2>
    <h4 *ngIf="!equipmentId" class="equipment-no-data">
      No Equipment Found in the Inventory for the given Serial Number
    </h4>
  </div>

  <!-- Equipment Info -->
   <div class="equipment-content">
  <div class="equipment-info row"  *ngIf="equipmentType">
    <label class="equipment-label">
      {{ equipmentType }}:
    </label>
    <input
      name="equipmentName"
      maxlength="80"
      class="equipment-input"
      [value]="equipmentName"
      readonly
    />
  </div>
    <div class="equipment-info row"  *ngIf="equipmentType">
     <label class="equipment-label">
      Description:
    </label>
    <input
      name="equipmentDesc"
      maxlength="80"
      class="equipment-input"
      [value]="equipmentDesc"
      readonly
    />
    </div>
    <div class="equipment-info row"  *ngIf="equipmentType">
    <label class="equipment-label">
      Serial Number:
    </label>
    <input
      name="serialNumber"
      maxlength="80"
      class="equipment-input"
      [value]="serialNumber"
      readonly
    />
    </div>
    <div class="equipment-info row"  *ngIf="equipmentType">
    <label class="equipment-label">
      Bar Code:
    </label>
    <input
      name="barCode"
      maxlength="80"
      class="equipment-input"
      [value]="barCode"
      readonly
    />
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="equipment-actions" *ngIf="equipmentType === 'Equipment'">
    <!-- Dialysis Machines -->
    <ng-container *ngIf="categoryName === 'Dialysis Machines'">
      <button (click)="openHistory(equipmentId)">Info</button>
      <button (click)="openDMIncident()">Incident</button>
      <button (click)="openRepairDetails()">Repair</button>
      <button (click)="openFilterDetails()">Filter</button>
      <button (click)="openDMHours()">Hours</button>
    </ng-container>

    <!-- Water Process -->
    <ng-container *ngIf="categoryName === 'Water Process'">
      <button (click)="openHistory(equipmentId)">Info</button>
      <button (click)="openWPDailyDetails()">Daily</button>
      <button (click)="openWPRepairDetails()">Repair</button>
      <button (click)="RouteClick('WaterProcess/RemoteView/RemoteView')">
        Remote View
      </button>
    </ng-container>

    <!-- Other Equipment -->
    <ng-container *ngIf="categoryName === 'Other Equipment'">
      <button (click)="openHistory(equipmentId)">Info</button>
      <button>Repair</button>
    </ng-container>
  </div>

  <!-- Parts -->
  <div class="equipment-actions" *ngIf="equipmentType === 'Part'">
    <button (click)="openPartInfo()">Details</button>
    <button (click)="openUpdateInventory()">Update Inventory</button>
  </div>

  <div class="equipment-info row" *ngIf="!equipmentId">
     <label class="equipment-label">
      Serial Number:
    </label>
    <input
      name="serialNumber"
      maxlength="80"
      class="equipment-input"
      [value]="serialNumber"
      readonly
    />
    </div>
 <div class="equipment-info row" *ngIf="!equipmentId">
  <label class="equipment-label">Category:</label>
  <mat-button-toggle-group
    name="toggleGroup"
    [(ngModel)]="selectedCategory">
    
    <mat-button-toggle 
      *ngFor="let category of CategoryList" 
      [value]="category.value"
      style="font-weight: normal !important;">
      {{ category.text }}
    </mat-button-toggle>

  </mat-button-toggle-group>
</div>
    <div class="equipment-info row" *ngIf="!equipmentId">
      <label class="equipment-label">
        Inventory Type:
      </label>
       <mat-button-toggle-group
          name="toggleGroup" style="font-weight: normal !important;"
          [(ngModel)]="selectedInventoryType"
          appearance="standard">
            <mat-button-toggle value="EQUIPMENT" style="font-weight: normal !important;">EQUIPMENT</mat-button-toggle>
            <mat-button-toggle value="PARTS" style="font-weight: normal !important;">PARTS</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <div class="equipment-actions"  *ngIf="!equipmentId">
      <button (click)="openPartDetails()">Add Inventory</button>
    </div>
    
  </div>
    </div>
  </section>
</section>